module.exports = __webpack_public_path__ + "img/salam-3.3cc0664b.png";